import { z } from "zod";

const hardGateStrategyConfigSchema = z.object({
  strategy: z.string(),
  builderModel: z.string(),
  gateContentUrl: z.string(),
});

const hardGateConfigSchema = z.array(hardGateStrategyConfigSchema);

export type HardGateStrategyConfig = z.infer<typeof hardGateStrategyConfigSchema>;
export type HardGateConfig = z.infer<typeof hardGateConfigSchema>;

export function parseHardGateConfig(raw: string | undefined): HardGateConfig {
  if (!raw) {
    return [];
  }

  try {
    const parsed = JSON.parse(raw);
    return hardGateConfigSchema.parse(parsed);
  } catch {
    return [];
  }
}

export function isModelInHardGateConfig(model: string, config: HardGateConfig): boolean {
  return config.some((entry) => entry.builderModel === model);
}
